import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  usageStatistics: [],
  loading: false,
  error: null,
};

const usageStatisticsSlice = createSlice({
  name: "usageStatistics",
  initialState,
  reducers: {
    fetchUsageStatisticsSuccess: (state, action) => {
      state.loading = false;
      state.usageStatistics = action.payload;
    },
    fetchUsageStatisticsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchUsageStatisticsSuccess, fetchUsageStatisticsFailure } =
  usageStatisticsSlice.actions;

export default usageStatisticsSlice.reducer;
